import Server from "../server";
import View from "../framework/view";
import template from "../../pugc/delivery";
import {Order} from "../bo/order";
import {format, parseISO} from "date-fns";
import {MapOrdersNotification, ViewOrderNotification} from "./wrb";
import jQuery from "jquery";
import {calcStateClass} from "./delivery";
import {getDirectionsUrl} from "../misc/orders";

export class PickupView extends View {

    static classname = "pickup-view";

    private readonly server = Server.instance();

    private orders : Order[] | undefined;

    constructor() {
        super(PickupView.classname);
        this.refresh();
    }

    refresh() {
        const orders_ = this.server.getPickups();

        orders_.then((orders) => {
            this.orders = orders;
            this.update();
        });
    }

    protected render0(): JQuery<HTMLElement> {

        const renderCreatedDate = (d: string) => {
            return format(parseISO(d), "yyyy-MM-dd HH:mm");
        };

        const renderDeliveryNote = (order: Order) => {
            const notes = [];
            for (const line of order.lineItems || []) {
                // @ts-ignore
                for (const note of line.customTextFields || []) {
                    if (note.title == "Pick up or delivery date:") {
                        notes.push(note.value);
                    }
                }
            }
            const n = notes.join(";")
            return n;
        };

        const data = {
            orders: this.orders,
            renderCreatedDate: renderCreatedDate,
            renderDeliveryNote: renderDeliveryNote,
            calcStateClass: calcStateClass,
            emptyMessage: "No items waiting delivery pickup",
            suppressActions: true,
            getDirectionsUrl: getDirectionsUrl,
        };

        const out = this.pug(template, data);
        return out;
    }

    show(id: string) {
        this.notify(new ViewOrderNotification(id));
    }

    showMap() {
        if (! this.orders) {
            return;
        }
        const ids = this.orders.map((order) => order.id).filter((id) => id);
        this.notify(new MapOrdersNotification(ids as string[]));
    }
}

View.on(
    "." + PickupView.classname,
    "click",
    ".orderClickable",
    function(that: PickupView, event, elt) {
        event.preventDefault();
        const id = jQuery(elt).closest(".order").data("orderid") as string;
        that.show(id);
    });

View.on(
    "." + PickupView.classname,
    "click",
    ".map",
    function(that: PickupView, event, elt) {
        event.preventDefault();
        that.showMap();
    });
